import React from 'react';
import { Row, Col, Button } from 'antd';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import styles from './pending-survey.module.css';

const PendingSurvey = ({ completionUrl }) => {
  const [t] = useTranslation();
  return (
    <Row align="center">
      <Col xs={24} className={styles.container}>
        <div className={styles.icon_wrapper}>
          <ExclamationCircleOutlined />
        </div>
        <div className={styles.message_wrapper}>
          <h2>{t('pages.data.pendingSurvey.messagePending')}</h2>
          <div className={styles.button_wrapper}>
            <Button type="primary" size="large">
              <a target="_blank" href={completionUrl} rel="noreferrer">
                {t('pages.data.pendingSurvey.continueButton')}
              </a>
            </Button>
          </div>
        </div>
      </Col>
    </Row>
  );
};

PendingSurvey.defaultProps = {
  completionUrl: '',
};

export default PendingSurvey;
